// src/pages/ChildrenManagementPage.js
import React, { useState, useEffect } from 'react';
import { Typography, Container, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import {
  fetchChildrenByGroup,
  addChild,
  updateChild,
  deleteChild,
} from '../actions/childActions';
import ChildrenList from '../components/ChildrenList';
import ChildForm from '../components/ChildrenForm';
import { useParams } from 'react-router-dom';

const ChildrenManagementPage = () => {
  const { groupId } = useParams();
  const dispatch = useDispatch();
  const [openChildForm, setOpenChildForm] = useState(false);
  const [currentChild, setCurrentChild] = useState(null);

  useEffect(() => {
    dispatch(fetchChildrenByGroup(groupId));
  }, [dispatch, groupId]);

  const handleAddChild = () => {
    setCurrentChild(null);
    setOpenChildForm(true);
  };

  const handleEditChild = (child) => {
    if (!child) {
      console.error('No child data provided to edit.');
      return;
    }
    setCurrentChild({ ...child });
    setOpenChildForm(true);
  };

  const handleDeleteChild = (child_id) => {
    dispatch(deleteChild(child_id));
  };

  const handleChildSubmit = (childData) => {
    if (currentChild) {
      dispatch(updateChild(currentChild.child_id, { ...childData, group_id: groupId }));
    } else {
      dispatch(addChild({ ...childData, group_id: groupId }));
    }
    setOpenChildForm(false);
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Gestionarea Copiilor pentru Grupul: {groupId}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddChild}
        style={{ marginBottom: '16px' }}
      >
        Adaugă Copil
      </Button>
      <ChildrenList onEdit={handleEditChild} onDelete={handleDeleteChild} />
      <ChildForm
        open={openChildForm}
        onClose={() => setOpenChildForm(false)}
        onSubmit={handleChildSubmit}
        child={currentChild}
      />
    </Container>
  );
};

export default ChildrenManagementPage;
